export default "__VITE_ASSET__D9yKJi5k__"